import React from 'react';
import { useIntl } from 'umi';
import { inject, observer } from 'mobx-react';
import { RootStore } from '@/models';
import ActionBtn, { ActionProps } from '../ActionBtn';
import styles from './index.less';
import { InterpretationStatus } from '@/models/simultaneousInterpretation';
import classNames from 'classnames';
import SwitchLanguage from '../../SwitchLanguage';
import SwitchChannel from '../../SwitchChannel';

interface Props extends Partial<Pick<RootStore, 'meeting'>>, Pick<ActionProps, 'order'> {
  simultaneous?: RootStore['simultaneousInterpretation'];
  className?: string;
}
const SimultaneousInterpretationBtnH5: React.FC<Props> = inject(({ store }) => {
  return {
    simultaneous: store.simultaneousInterpretation,
  };
})(
  observer((props) => {
    const { simultaneous, order, className } = props;
    const { formatMessage } = useIntl();

    return (
      <>
        {simultaneous?.interpretationStatus === InterpretationStatus.starting ? (
          <SwitchChannel>
            <ActionBtn
              order={order}
              bottomTitle={formatMessage({ id: 'INTERPRETATION' })}
              className={classNames(styles.SIBtn, className)}
            >
              <SwitchLanguage />
            </ActionBtn>
          </SwitchChannel>
        ) : null}
      </>
    );
  })
);

export default SimultaneousInterpretationBtnH5;
